// sans manoeuvre + need dimensions

import formInputsTypes, { LameColor } from '../simulatorConstant';
import Cassette from 'assets/img/cassette.png';
import Rainure from 'assets/img/rainure.png';
import Lisse from 'assets/img/lisse.png';

// 1) Motif (last step here; you can continue after this if you want)
export const panneauMotif = {
	id: 'PG-PAN-MOTIF',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'panneauMotif',
	className: 'col-12',
	label: 'Motif',
	nextStepData: false, // or next step (summary / contact / etc.)
	options: [
		{
			id: 'PG-PAN-MOTIF-LIS',
			label: 'Lisse',
			value: 'Lisse',
			imageUrl: Lisse,
			description:
				'Panneau à surface plane, offrant un rendu sobre et moderne. ' +
				'Facile d’entretien, il s’intègre discrètement à tous les styles de façade.',
		},
		{
			id: 'PG-PAN-MOTIF-RAI',
			label: 'Rainuré',
			value: 'Rainuré',
			imageUrl: Rainure,
			description:
				'Panneau avec rainures horizontales régulières, apportant du relief et une meilleure perception visuelle. ' +
				'Ce motif est couramment utilisé sur les portes sectionnelles.',
		},
		{
			id: 'PG-PAN-MOTIF-CAS',
			label: 'Cassette',
			value: 'Cassette',
			imageUrl: Cassette,
			description:
				'Panneau à motif cassette, composé de cadres en relief pour un aspect plus traditionnel ou décoratif. ' +
				'Souvent choisi pour des façades de caractère.',
		},
	],
};

// 2) Couleur
const couleur = {
	id: 'VR-TR-TB-CC',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'Couleur du panneau',
	classGroup: 'Couleur du panneau',
	label: 'Couleur du panneau',
	defaultValue: 0,
	nextStepData: panneauMotif,
	options: [
		{
			id: 6,
			label: 'Blanc RAL 9016',
			color: '#ffffff',
			icon: 'CustomCircle',
			value: 6,
			description: '- Couleur blanc RAL 9016, aspect clair et standard.',
		},
		{
			id: 14,
			label: 'Anthracite RAL 7016',
			color: '#383e42',
			icon: 'CustomCircle',
			value: 14,
			description: '- Couleur gris anthracite RAL 7016, aspect moderne.',
		},
	],
};
// 3) Nombre de panneaux/lames
export const panneauNombre = {
	id: 'PG-PAN-NB',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'panneauNombre',
	className: 'col-6',
	label: 'Nombre de panneaux / lames',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: couleur,
	validation: (v) => v >= 0,
};

// 4) Épaisseur
export const panneauEpaisseur = {
	id: 'PG-PAN-EP',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'panneauEpaisseur',
	className: 'col-6',
	label: 'Épaisseur du panneau (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: panneauNombre,
	validation: (v) => v > 0,
};

// 5) Hauteur du panneau
export const panneauHauteur = {
	id: 'PG-PAN-H',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'panneauHauteur',
	className: 'col-6',
	label: 'Hauteur du panneau (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: panneauEpaisseur,
	validation: (v) => v > 0,
};

// 6) Largeur du panneau
export const panneauLargeur = {
	id: 'PG-PAN-W',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'panneauLargeur',
	className: 'col-6',
	label: 'Largeur du panneau (mm)',
	placeholder: '0',
	defaultValue: 0,
	nextStepData: panneauHauteur,
	validation: (v) => v > 0,
};

// OPTIONAL: If you still want "position concernée" at the beginning
